<template lang="pug">
.error-401.text-large
  .error-401__message セッションがタイムアウトしました。
  a(:href='topPage') 戻る
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class Error401 extends Vue {
  private get topPage(): string {
    return this.$bcbtCookies.returnUrl.get()
  }
}
</script>

<style lang="stylus" scoped>
.error-401
  margin 50px

  &__message
    margin-bottom 20px
</style>
